import { render, staticRenderFns } from "./issue_milestone.vue.js?vue&type=template&id=5c6899c3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./issue_milestone.vue?vue&type=template&id=5c6899c3"
import script from "./issue_milestone.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./issue_milestone.vue?vue&type=script&lang=js"
export * from "./issue_milestone.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./issue_milestone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports